import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({   
  switch: {
    "& .Mui-checked": {
      color: '#fff'
    },
    '&  .Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#69ABCF',
      color: '#69ABCF',
      opacity: 1
    },
  },
  mainContent: {
    display: 'flex',
    marginTop: 20, 
    paddingBottom: 25, 
    paddingLeft: 20,
    paddingRight: 20
  }
});